import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { DetailedUser } from "@/user/user";

interface WithTechnician {
  technician: Pick<DetailedUser, "display_identification">;
}

const FlatTechnicianCol = <T extends WithTechnician>(): ColumnDef<T> => ({
  header: "Technician",
  accessorFn: (row) => row.technician.display_identification || "Unknown",
  cell: ({ getValue }) => {
    const technicianName = getValue() as string;
    return <LineClampedTooltip>{technicianName}</LineClampedTooltip>;
  },
});

export default FlatTechnicianCol;
